module.exports = __webpack_public_path__ + "f1c765fdf54dfdb26876623bf9a58df2.svg";